<template>
  <vue-final-modal
    name="dialog-modal"
    classes="modal-container"
    content-class="modal-content"
    height="auto"
    v-bind:model-value="show"
    :closeable="closeable"
    v-bind="$attrs"
    @close="close"
    @click-outside="close"
  >
    <div class="px-6">
      <div class="modal__title pt-4">
        <slot name="title" />
      </div>
      <div class="modal__content">
        <slot name="content" />
      </div>
      <div class="modal__action pb-2">
        <slot name="footer" />
      </div>
    </div>
  </vue-final-modal>
</template>

<script setup>
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  closeable: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['close']);

const close = () => {
  if (props.closeable) {
    emit('close');
  }
};
</script>
